<template>
  <el-table-column
    prop="category.name"
    label="Kategória"
    show-overflow-tooltip
    min-width="130"
    sortable="custom"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.shop_category_id">{{ scope.row.category.name }}</span>
      <el-tag type="danger" v-else size="small">Nincs kategória</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'category.name',
  };
</script>
